import React, { useState } from "react";
import {
  Form,
  Button,
  Upload,
  message,
  Card,
  Typography,
  Space,
  Alert,
} from "antd";
import { UploadOutlined, InfoCircleOutlined } from "@ant-design/icons";
import axiosInstance from "../api/axiosConfig";

const { Title } = Typography;

const UploadSalesReport = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = ({ fileList }) => {
    setFile(fileList && fileList.length > 0 ? fileList[0].originFileObj : null);
  };

  const handleSubmit = async () => {
    if (!file) {
      message.error("Por favor, seleccione un archivo Excel.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);
      const response = await axiosInstance.post(
        "/sales-reports/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      message.success(
        `Reporte subido exitosamente. ${response.data.recordsProcessed} registros procesados.`
      );
      setFile(null);
    } catch (error) {
      message.error(
        error.response?.data?.error || "Error al subir el reporte."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        background: "#1f1f1f",
        color: "#ccc",
        minHeight: "calc(100vh - 80px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px 20px",
      }}
    >
      <Card
        style={{
          maxWidth: 600,
          width: "100%",
          background: "#2a2a2a",
          color: "#ccc",
          border: "1px solid #444",
        }}
        bordered={false}
      >
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <Title level={3} style={{ textAlign: "center", color: "#fff" }}>
            Subir Reporte de Ventas
          </Title>

          <Alert
            message="Información Importante"
            description={
              <div>
                <p>El archivo Excel debe contener las siguientes columnas:</p>
                <ul>
                  <li>chasis</li>
                  <li>agencia_code</li>
                  <li>des_bodega</li>
                  <li>fecha_venta</li>
                </ul>
                <p>
                  Nota: Al subir un nuevo reporte, se eliminará el reporte
                  anterior.
                </p>
              </div>
            }
            type="info"
            showIcon
            icon={<InfoCircleOutlined />}
            style={{ background: "#ffffff", border: "1px solid #333" }}
          />

          <Form layout="vertical" onFinish={handleSubmit}>
            <Form.Item
              label={<span style={{ color: "#ccc" }}>Archivo Excel</span>}
              required
            >
              <Upload
                beforeUpload={() => false}
                onChange={handleFileChange}
                accept=".xls,.xlsx"
                maxCount={1}
                fileList={file ? [{ uid: "1", name: file.name }] : []}
              >
                <Button icon={<UploadOutlined />}>Seleccionar Archivo</Button>
              </Upload>
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block loading={loading}>
                Subir Reporte
              </Button>
            </Form.Item>
          </Form>
        </Space>
      </Card>
    </div>
  );
};

export default UploadSalesReport;
